import { ViewPreference } from 'src/app/models';

export interface AppState {
  selectedLanguage: string;
  viewPreference: ViewPreference;
}
